import create from 'zustand';
import produce from 'immer';
import { devtools } from 'zustand/middleware';
import { AuthState } from '../types/auth.d';
import { Roles } from '../utils/enums';

const store = (set): AuthState => ({
    user: {
        id: null,
        roles: [],
        username: '',
        email: '',
        token: ''
    },
    activeRole: '',
    activePartner: '',
    accessToken: '',
    authenticated: false,
    allowedRoutesForUser: [],
    setAccessToken: (token: string) => {
        set(
            produce((state: AuthState) => {
                state.accessToken = token;
            })
        );
    },
    setAuthenticated: (value: boolean) => {
        set(
            produce((state: AuthState) => {
                state.authenticated = value;
            })
        );
    },
    setUserDetails: (userDetails: any) => {
        set(
            produce((state: AuthState) => {
                state.user = userDetails;
            })
        );
    },
    setAllowedRoutesForUser: (value: Array<string>) => {
        set(
            produce((state: AuthState) => {
                state.allowedRoutesForUser = value;
            })
        );
    },
    setActiveRole: (role: string) => {
        set(
            produce((state: AuthState) => {
                state.activeRole = role;
            })
        );
    },
    setActivePartner: (partner: string) => {
        set(
            produce((state: AuthState) => {
                state.activePartner = partner;
            })
        );
    }
});

export const useAuthStore = create<AuthState>(devtools(store));
